import React, { Fragment } from 'react'
import styled from 'styled-components'
import { CSSTransition } from 'react-transition-group'

const FadeInFadeOut = ({
    children,
    fadeInTimer = 200,
    isOpen

}) => {
    if(isOpen == null) {
        //throw 'isOpen needs to be defined.'
    }
    return (
        <CSSTransition in={isOpen} timeout={fadeInTimer} unmountOnExit>
                <Fragment>
                    <StyledPopoverWrapper fadeInTimer={fadeInTimer}>
                        {children}
                    </StyledPopoverWrapper>
                </Fragment>
            </CSSTransition>
    )
}   

const StyledPopoverWrapper = styled.div`

    transition: opacity ${props => props.fadeInTimer}ms;
    position: absolute;

    &.enter {
      opacity: 0;
      z-index: var(--drawer-mask-z-index);
   }
   
   &.enter-active {
      opacity: 1;
      z-index: var(--drawer-mask-z-index);
   }
   
   &.exit {
      opacity: 1;
      z-index: var(--drawer-mask-z-index);
   }
   
   &.exit-active {
      opacity: 0;
      z-index: var(--drawer-mask-z-index);
   }
`

export default FadeInFadeOut